// tslint:disable:no-any
import React, { Component } from 'react';
import Dt from 'react-document-title';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { loadDives } from '../actions/diveActions';
import DivesFilterYears from '../components/DivesFilterYears';
import DivesTable from '../components/DivesTable';
import Loader from '../components/Loader';
import Title from '../components/Title';
import { NavigationStore } from './Navigation/NavigationStore';

// import Navigation from '../components/Navigation';

export interface IDivesProps {
    loadDives: () => void;
    dives: any;
    viewDetail: any;
    editDive: any;
}

interface IDivesState {
    year: any;
}

class Dives extends Component<IDivesProps, IDivesState> {
    constructor(props: IDivesProps) {
        super(props);
        this.state = {
            year: null
        };
    }

    componentDidMount() {
        this.refreshDives();
        NavigationStore.getInstance().setActive('dives');
        // Navigation._setActive('dives', 'My dives');
        window.scrollTo(0, 0);
    }

    refreshDives() {
        this.props.loadDives();
    }

    onYearSet(year: number) {
        this.setState({
            year: year
        });
    }

    render() {
        const { dives, viewDetail, editDive } = this.props;

        if (dives.userDives === undefined) {
            return <Loader />;
        }

        return (
            <Dt title={'WetNotes | My dives'}>
                <div className="dives">
                    <Title
                        heading={'My Dives'}
                        breadcrumbs={[
                            { caption: 'My Dives', to: '/app/dives' }
                        ]}
                    />

                    <div className="wrapper">
                        <div className="col__sidebar">
                            <DivesFilterYears
                                dives={dives.userDives}
                                onYearSet={(year: number) =>
                                    this.onYearSet(year)
                                }
                            />
                        </div>

                        <div className="col__main">
                            <DivesTable
                                title="My Dives"
                                shared={false}
                                year={this.state.year}
                                dives={dives.userDives}
                                viewDetail={viewDetail}
                                editDive={editDive}
                                refreshDives={() => this.refreshDives()}
                            />
                        </div>
                    </div>
                </div>
            </Dt>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dives: state.dives.items || []
});

const mapDispatchToProps = (dispatch: any) => ({
    loadDives: () => dispatch(loadDives()),
    viewDetail: (index: any) => dispatch(push(`/app/dives/${index}`)),
    editDive: (index: any) => dispatch(push(`/app/dive/edit/${index}`))
});

export default connect(mapStateToProps, mapDispatchToProps)(Dives);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dives.tsx